import { Colors } from 'enums';
import { css } from 'styled-components';

const SCROLL_WIDTH = 4;
export const INDENT_FOR_SCROLL = 2;
export const PADDING_DIFF_FOR_SCROLL = SCROLL_WIDTH + INDENT_FOR_SCROLL;

export const CSS_FOR_SCROLL = css`
  scroll-behavior: smooth;

  ::-webkit-scrollbar {
    width: ${SCROLL_WIDTH}px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: ${Colors.yellow1};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${Colors.yellow2};
  }
`;
